export class Mouvement {
  constructor(options = {}) {
    this.beginningDate = options.beginningDate
    this.endingDate = options.endingDate
    this.identifier = options.identifier
  }
}



// WEBPACK FOOTER //
// ./src/client/common/models/mouvement.js